import React from 'react';
import * as styles from './MinimalLayout.module.scss';
import MinimalHeader from '../MinimalHeader';

type Props = {
  children: React.ReactNode;
};

// search for "layout 'minimal'" in rb for backend configuration
function MinimalLayout({ children }: Props) {
  return (
    <div className={styles.minimal}>
      <MinimalHeader />
      {children}
    </div>
  );
}

export default MinimalLayout;
